"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _WalletRowContainer = _interopRequireDefault(require("./WalletRowContainer"));
var _FiatDeposit = require("../Retail/RetailSidePanes/FiatDeposit");
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
require("./WalletRowList.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var walletRowListClasses = (0, _cssClassesHelper.getBEMClasses)('wallet-row-list');
var WalletRowListComponent = function WalletRowListComponent(props) {
  if (props.fetching) {
    return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
      customClass: walletRowListClasses
    });
  }
  var items = props.products.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_WalletRowContainer["default"], {
      key: item.ProductId,
      productId: item.ProductId,
      detailsLink: props.detailsLink
    });
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: walletRowListClasses()
  }, items, /*#__PURE__*/_react["default"].createElement(_FiatDeposit.DepositReferenceIdModalContainer, null));
};
var _default = exports["default"] = WalletRowListComponent;